export const customer = ({ current }, getters) => {
  return getters.customerById(current);
};

export const customerById = ({ all }) => id => {
  return all[id] || null;
};

export const customerLevels = ({ levels }) => {
  if (!levels) {
    return [];
  }

  levels = Object.values(levels);

  return levels.sort(
    (a, b) => a.thresholdAmount.amount - b.thresholdAmount.amount
  );
};

export const cashbackAvailablePoints = (state, getters) => {
  if (!getters.customer) {
    return 0;
  }

  return getters.customer.cashbackAvailablePoints || 0;
};

export const customerLevel = (state, getters) => {
  if (!getters.customer || !getters.customer.levelId) {
    return null;
  }

  return getters.customerLevelById(getters.customer.levelId) || null;
};

export const customerLevelById = ({ levels }) => id => {
  return levels[id] || null;
};

export const customers = ({ all }) => {
  return Object.values(all) || [];
};

export const isOnBoardingRequired = (state, getters) => {
  return getters.customer && !getters.customer.isFirstClubEligible;
};
